module.exports = __webpack_public_path__ + "static/media/Kiosk-Ultra-wht.92873633.png";